import { parse } from 'date-fns';
import { tz } from '@date-fns/tz';
import type { HolidayBannerConfig } from '../../constants/campaign/holidayBanner';
import {
  HOLIDAY_BANNER_ROTATIONS,
  HOLIDAY_BANNER_TIMEZONE,
  DEFAULT_HOLIDAY_BANNER,
} from '../../constants/campaign/holidayBanner';

/**
 * Checks if the current time falls within a banner's time range
 *
 * @param banner The banner config to check
 * @param now The current date/time
 * @param pattern Date parse pattern
 * @returns true if banner is active, false otherwise
 */
const isBannerActive = (banner: HolidayBannerConfig, now: Date, pattern: string): boolean => {
  const startDateTime = parse(banner.startDate, pattern, new Date(), { in: tz(HOLIDAY_BANNER_TIMEZONE) });
  const endDateTime = parse(banner.endDate, pattern, new Date(), { in: tz(HOLIDAY_BANNER_TIMEZONE) });

  return now >= startDateTime && now < endDateTime;
};

/**
 * Gets the active Holiday Banner configuration based on current time in SGT
 * Returns the default purple banner if no scheduled banner is active
 *
 * @param pattern Optional custom date-fns parse pattern. Defaults to 'yyyy-MM-dd HH:mm:ss'
 * @returns The active banner config, or default banner if none is active
 */
export const getActiveHolidayBanner = (pattern = 'yyyy-MM-dd HH:mm:ss'): HolidayBannerConfig => {
  const now = new Date();

  return HOLIDAY_BANNER_ROTATIONS.find((banner) => isBannerActive(banner, now, pattern)) ?? DEFAULT_HOLIDAY_BANNER;
};
